import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import MapSelectorSpec from "./MapSelectorSpec";
import ModelSelectorSpec from "./ModelSelectorSpec";
import ModelBasedSelectorSpec from "./ModelBasedSelectorSpec";
import idArgSelector from "./idArgSelector";
import QuerySet from "../QuerySet";
import Model from "../Model";
import ForeignKey from "../fields/ForeignKey";
import ManyToMany from "../fields/ManyToMany";

var FieldSelectorSpec = /*#__PURE__*/function (_ModelBasedSelectorSp) {
  _inheritsLoose(FieldSelectorSpec, _ModelBasedSelectorSp);

  function FieldSelectorSpec(_ref) {
    var _this;

    var field = _ref.field,
        fieldModel = _ref.fieldModel,
        accessorName = _ref.accessorName,
        isVirtual = _ref.isVirtual,
        other = _objectWithoutProperties(_ref, ["field", "fieldModel", "accessorName", "isVirtual"]);

    _this = _ModelBasedSelectorSp.call(this, other) || this;
    _this._field = field;
    _this._fieldModel = fieldModel;
    _this._accessorName = accessorName;
    _this._isVirtual = isVirtual;
    return _this;
  }

  var _proto = FieldSelectorSpec.prototype;

  _proto.valueForInstance = function valueForInstance(instance, session) {
    if (!instance) {
      return null;
    }

    var value;

    if (this._parent instanceof ModelSelectorSpec) {
      /* orm.Model.field */
      value = instance[this._accessorName];
    } else {
      /* orm.Model.field1.field2..fieldN.field */
      var ParentToModel = session[this._parent.toModelName];

      var parentRef = this._parent.valueForInstance(instance, session);

      var parentInstance = parentRef ? new ParentToModel(parentRef) : null;
      value = parentInstance ? parentInstance[this._accessorName] : null;
    }

    if (value instanceof Model) {
      return value.ref;
    }

    if (value instanceof QuerySet) {
      return value.toRefArray();
    }

    return value;
  };

  _proto.map = function map(selector) {
    if (selector instanceof ModelSelectorSpec) {
      if (this.toModelName === selector.model.modelName) {
        throw new Error("Cannot select models in a `map()` call. If you just want the `".concat(this._accessorName, "` as a ref array then you can simply drop the `map()`. Otherwise make sure you're passing a field selector of the form `").concat(this.toModelName, ".<field>` or a custom selector instead."));
      } else {
        throw new Error("Cannot select `".concat(selector.model.modelName, "` models in this `map()` call. Make sure you're passing a field selector of the form `").concat(this.toModelName, ".<field>` or a custom selector instead."));
      }
    } else if (selector instanceof FieldSelectorSpec || selector instanceof MapSelectorSpec) {
      if (this.toModelName !== selector.model.modelName) {
        throw new Error("Cannot select fields of the `".concat(selector.model.modelName, "` model in this `map()` call. Make sure you're passing a field selector of the form `").concat(this.toModelName, ".<field>` or a custom selector instead."));
      }
    } else if (!selector || typeof selector !== "function" || !selector.recomputations) {
      throw new Error("`map()` requires a selector as an input. Received: ".concat(JSON.stringify(selector), " of type ").concat(_typeof(selector)));
    }

    if (!(this._field instanceof ForeignKey) && !(this._field instanceof ManyToMany)) {
      throw new Error("Cannot map selectors for non-collection fields");
    }

    return new MapSelectorSpec({
      parent: this,
      model: this._model,
      orm: this._orm,
      field: this._field,
      selector: selector
    });
  };

  _createClass(FieldSelectorSpec, [{
    key: "key",
    get: function get() {
      return this._accessorName;
    }
  }, {
    key: "dependencies",
    get: function get() {
      return [this._orm, idArgSelector];
    }
  }, {
    key: "toModelName",
    get: function get() {
      return this._field.toModelName === "this" ? this._fieldModel.modelName : this._field.toModelName;
    }
  }, {
    key: "toModel",
    get: function get() {
      var db = this._orm.getDatabase();

      return db.describe(this.toModelName);
    }
  }]);

  return FieldSelectorSpec;
}(ModelBasedSelectorSpec);

export { FieldSelectorSpec as default };